import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { App } from "./App.js";

// Mount on the root element. The content bundle can take over visible DOM if needed.
const shellMount = document.getElementById("root") ?? document.body;

ReactDOM.createRoot(shellMount).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
